import { heDecodeOrDefault } from "~/lib/shared/html-utils";
import { DatavizChart } from "~/types/asgard/DatavizChart";
import { EvervizChartProps } from "./EvervizChart";

export const apiDatavizToEvervizChartProps = (
  chartData: DatavizChart,
  headlineId?: string
): EvervizChartProps => ({
  headlineId: heDecodeOrDefault(headlineId),
  headline: heDecodeOrDefault(chartData.headline),
  subtitle: heDecodeOrDefault(chartData.subtitle),
  title: heDecodeOrDefault(chartData.title),
  footnote: heDecodeOrDefault(chartData.footnote),
  logo: heDecodeOrDefault(chartData.logo),
  image: heDecodeOrDefault(chartData.image),
  altText: heDecodeOrDefault(chartData.image_alt),
  injectId: heDecodeOrDefault(chartData.injectId),
  chartId: heDecodeOrDefault(chartData.chartId),
  methodology: heDecodeOrDefault(chartData.methodology),
});
